import { QUERY_KEYS } from "@/common/query-keys";
import { createHardware, CreateHardwarePayload } from "@/lib/snipeit/hardware";
import * as Sentry from "@sentry/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export interface BookinResponse {
  successes: CreateHardwarePayload[];
  failures: { item: CreateHardwarePayload; error: string }[];
}

export function useBookinHardware() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (items: CreateHardwarePayload[]): Promise<BookinResponse> => {
      const successes: CreateHardwarePayload[] = [];
      const failures: { item: CreateHardwarePayload; error: string }[] = [];

      for (const item of items) {
        try {
          await createHardware(item);
          successes.push(item);
        } catch (err) {
          failures.push({ item, error: err instanceof Error ? err.message : String(err) });
        }
      }
      return { successes, failures };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.dashboardModelCount] });
    },
    onError: (err) => {
      Sentry.captureException(err);
      toast.error(err instanceof Error ? err.message : "Ein Fehler ist aufgetreten.");
    },
  });
}
